<div class="flex flex-col gap-6">
    <div>
        <div class="flex flex-wrap justify-between items-center gap-2 md:gap-4">
            <span class="typography-title-l">
                {{'natural_stone.added_natural_stone' | translate}}
            </span>
            <span class="typography-body-l-regular text-text-tertiary">
                {{(getTotalInCart() === 0 || getTotalInCart() > 1 ? 'natural_stone.added_slabs_plural' : 'natural_stone.added_slabs_singular') | translate:{varSlabs: getTotalInCart()} }}
            </span>
        </div>
        <div class="mt-6 border-b border-divider-divider"></div>
    </div>
    <div class="flex flex-col gap-6">
        <div *ngFor="let line of cart(); let last = last" class="px-4 md:px-6">
            <app-natural-stone-cart-line [line]="line"></app-natural-stone-cart-line>
            <div [ngClass]="{'border-b border-divider-divider': !last}" class="mt-6 "></div>
        </div>
    </div>
    <div>
        <alert type="warning">
            <span class="typography-body-l-medium">
                {{'natural_stone.please_note_that_the_selected_slabs_are_not_locked_so_they_may_become_unavailable_during_the_process' | translate}}
            </span>
        </alert>
    </div>
</div>